// src/pages/AiResolvedPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../hooks/useApi';
import { fmtDateTime, timeAgo } from '../utils/formatters';

export default function AiResolvedPage({ showToast }) {
  const [logs, setLogs] = useState([]);
  const { request, loading } = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    request('/api/admin/analytics')
      .then(data => {
        if (data && data.ai_logs) setLogs(data.ai_logs);
      })
      .catch(err => showToast(err.message, 'error'));
  }, [request, showToast]);

  return (
    <div className="ai-resolved-page">
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div>
          <h1 className="page-title" style={{ margin: 0 }}>AI Resolved Issues</h1>
          <p className="page-subtitle" style={{ margin: '4px 0 0 0' }}>Detailed logs of issues prevented/resolved by AI assistant.</p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <button onClick={() => navigate(-1)} className="nav-icon-btn" title="Go Back">←</button>
        </div>
      </div>

      <div className="card p-6 border-blue mt-6">
        <div className="overflow-x-auto">
          <table className="ticket-table">
            <thead>
              <tr>
                <th style={{ width: '150px' }}>Date</th>
                <th style={{ width: '120px' }}>User</th>
                <th style={{ width: '250px' }}>Issue Title</th>
                <th>AI Recommendation / Description</th>
              </tr>
            </thead>
            <tbody>
              {loading && !logs.length && (
                <tr><td colSpan="4" className="text-center p-12"><div className="spinner sm mx-auto"></div></td></tr>
              )}
              {!loading && logs.length === 0 && (
                <tr><td colSpan="4" className="text-center p-12 text-muted">No AI resolution logs found.</td></tr>
              )}
              {logs.map(log => {
                let aiData = null;
                try {
                  if (typeof log.ai_response === 'string') aiData = JSON.parse(log.ai_response);
                  else aiData = log.ai_response;
                } catch (e) { }

                return (
                  <tr key={log.id}>
                    <td className="whitespace-nowrap">
                      <div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-secondary)' }}>
                        {log.created_at ? timeAgo(log.created_at) : `Log #${log.id}`}
                      </div>
                      <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '2px' }}>
                        {log.created_at ? fmtDateTime(log.created_at) : '—'}
                      </div>
                    </td>
                    <td className="font-medium">{log.username || 'System'}</td>
                    <td className="font-semibold text-blue">{log.title}</td>
                    <td className="text-sm" style={{ lineHeight: '1.6' }}>
                      <div className="text-dark font-medium mb-1" style={{ whiteSpace: 'pre-wrap' }}>{log.description}</div>
                      {aiData?.suggested_fix && (
                        <div className="mt-2 p-3 bg-indigo-50 border border-indigo-100 rounded-md">
                          <div className="text-xs font-bold text-indigo-700 uppercase mb-1">AI Recommendation:</div>
                          <ul className="m-0 pl-4 text-indigo-900">
                            {Array.isArray(aiData.suggested_fix)
                              ? aiData.suggested_fix.map((f, i) => <li key={i}>{f}</li>)
                              : <li>{aiData.suggested_fix}</li>
                            }
                          </ul>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
